<section class="public-footer">
  <div class="top-wrap">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-lg-5 left-wrap">
          <div class="inner">
            <h3 class="hdg">Stay In The Know</h3>
            <p class="des">
              Get exclusive auction alerts from The Branford Group <br />
              straight to your inbox.
            </p>

            <div class="subscribe-form">
              <input class="form-control footer-serach" id="sub-footer-input" placeholder="Your Email" [formControl]="emailSubscription"
                [maxLength]="maxlengthShorter" />
              <button type="button" class="btn btn-colored" [disabled]="emailSubscription.invalid" role="button"
                (click)="openModal(subscribeModal)">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-7 right-wrap">
          <div class="parts">
            <h4 class="small-headings">About</h4>
            <ul class="footer-menu no-list mb-3">
              <li>
                <a [routerLink]="[routes.team]">Meet Our Team</a>
              </li>
              <li>
                <a [routerLink]="[routes.about]">Services</a>
              </li>
              <li>
                <a [routerLink]="[routes.blogList]">News</a>
              </li>
              <li>
                <a [routerLink]="[routes.valuations]">Valuations</a>
              </li>
              <li>
                <a [href]="[routes.bgiSurplusLink]" target="_blank">BGI Surplus</a>
              </li>
            </ul>
          </div>

          <div class="parts">
            <h4 class="small-headings">Support</h4>
            <ul class="footer-menu no-list mb-3">
              <li>
                <a [routerLink]="[routes.faq]">FAQs</a>
              </li>
              <li>
                <a [routerLink]="[routes.sellers]">Sellers</a>
              </li>
              <li>
                <a [routerLink]="[routes.removal]">Removal/Rigging</a>
              </li>
              <li>
                <a [routerLink]="[routes.payments]">Payments</a>
              </li>
            </ul>
          </div>

          <div class="parts">
            <h4 class="small-headings">Contact Info:</h4>
            <div class="contact-details">
              <p class="contact-des">
                Business Hours: Monday-Friday, 9-5 Eastern
              </p>
              <p class="contact-des">Call Us: 203-488-7020</p>
              <p class="contact-des">
                Email Us:
                <a href="mailto:Service@theBranfordGroup.com">Service@theBranfordGroup.com</a>
              </p>
              <p class="contact-des">
                896 Main St <br />
                Branford, CT 06405
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="public-footer-copy">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <p class="des m-0">
            Copyright &copy; {{ currentYear }} Branford Auctions, LLC. Branford Valuations,
            LLC
          </p>
        </div>
        <div class="col-6 col-md-4 col-lg-2 mt-4 mt-lg-0">
          <ul class="footer-menu no-list">
            <li>
              <a [routerLink]="[routes.terms]">Terms &amp; Conditions</a>
            </li>
          </ul>
        </div>
        <div class="col-4 col-md-4 col-lg-2 mt-4 mt-lg-0">
          <ul class="footer-menu no-list">
            <li>
              <a [routerLink]="[routes.policy]">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-4 col-lg-auto ml-md-auto mt-4 mt-lg-0">
          <a class="mr-2" href="https://www.facebook.com/The-Branford-Group-126397777391858/" target="_blank">
            <img src="../assets/images/facebook.svg" />
          </a>
          <a class="mr-2" href="https://twitter.com/TBGAuctions/" target="_blank">
            <img src="../assets/images/twitter.svg" />
          </a>
          <a class="mr-2" href="https://www.instagram.com/thebranfordgroup/?hl=en" target="_blank">
            <img src="../assets/images/instagram.svg" />
          </a>
          <a class="mr-2" href="https://www.youtube.com/user/BranfordAuctions" target="_blank">
            <img src="../assets/images/youtube.svg" />
          </a>
          <a href="https://www.linkedin.com/company/the-branford-group" target="_blank">
            <img src="../assets/images/linkedin.svg" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

  <div id="cc-subscribeform" style="display: none;">
    <!-- Begin Constant Contact Inline Form Code -->
    <div class="ctct-inline-form" data-form-id="eca0dd54-4b28-483b-972c-f75f4db5859e"></div>
    <!-- End Constant Contact Inline Form Code -->
  </div>

<ng-template #subscribeModal>
  <div class="modal-header pb-0">
    <h4 class="modal-title pull-left">&nbsp;</h4>
    <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="close-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body" id="subscribeModal-body-footer">
  </div>
</ng-template>
